<script>

import countriesDataset from '@/data/countries-dataset';

export default {
  name: 'Countries',
  data() {
    return {
      countries: countriesDataset,
    };
  },
};
</script>
